import React from "react";
import { doc, deleteDoc, addDoc, onSnapshot, updateDoc, query, orderBy } from "firebase/firestore";
import SlotList from './SlotList';
import {
    findInsertedOrder, findAppendedOrder
} from '../utils/OrderEncoderUtils'
import DynamicSlot from "./DynamicSlot";
import {OPERATION_FAILED, WRITE_FAILED_DETAIL} from "../utils/Constants";
import lodash from "lodash";

export default class DynamicSlotList extends SlotList {
    constructor(props) {
        super(props);
        this.Slot = <DynamicSlot rootPath={this.props.rootPath} selectedShade={this.props.selectedShade}/>;
        this.order = {};
        onSnapshot(query(this.props.rootPath, orderBy("order")), (querySnapshot) => {
            let orderToSlotIndex = [];
            querySnapshot.forEach((document) => {
                let data = document.data();
                this.dataAttributes[document.id] = this.getDefaultAttributes();
                for (let key of Object.keys(data.attributes)) {
                    this.dataAttributes[document.id][key] = data.attributes[key];
                }
                this.slotRefs[document.id] = this.slotRefs[document.id] || React.createRef();
                this.order[document.id] = data.order;
                orderToSlotIndex.push(document.id);
                //console.log(`${document.id} => ${JSON.stringify(data)}`);
            });

            let activeSlotId = this.state.activeSlotId || (orderToSlotIndex.length > 0 ? orderToSlotIndex[orderToSlotIndex.length - 1] : undefined);
            querySnapshot.forEach((document) => {
                let data = document.data();
                if (this.props.selected && activeSlotId === document.id) {
                    //this.props.propChangeAction({"tableColor": data.attributes.color});
                    let scheduleData = this.slotRefs[document.id].current ? this.slotRefs[document.id].current.getScheduleData() : undefined;
                    if (data.scheduleData && data.scheduleData.data) {
                        data.scheduleData.data = JSON.parse(data.scheduleData.data)
                        let newScheduleData = [data.scheduleData.data, data.scheduleData.scheduleStartDay, data.scheduleData.scheduleEndDay, data.scheduleData.scheduleStartTime, data.scheduleData.scheduleEndTime, data.scheduleData.timeFormat, data.scheduleData.selectAll]
                        if (!lodash.isEqual(scheduleData, newScheduleData)) {
                            this.props.dataChangeAction(newScheduleData);
                        }
                    }
                }
            });
            
            this.setState({orderToSlotIndex: orderToSlotIndex, activeSlotId: activeSlotId}, () => {
                this.props.onLoadFinish();
            })
        }, () => {
			this.props.propChangeAction({"notFound": true});
		});
    }

    onDragEnd(result) {
        const { destination, source, } = result;
        if (!destination) {
            return;
        }
        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        let orderToSlotIndex = this.state.orderToSlotIndex;
        let sourceKey = orderToSlotIndex.splice(source.index, 1)[0];

        let orders = orderToSlotIndex.map((key) => this.order[key]);
        let newOrder = findInsertedOrder(orders, destination.index);
        updateDoc(doc(this.props.rootPath, sourceKey), {
            order: newOrder
        }).catch(() => {
            this.props.displayMessage(`${OPERATION_FAILED} ${WRITE_FAILED_DETAIL}`);
        });

        orderToSlotIndex.splice(destination.index, 0, sourceKey)
        this.setState({orderToSlotIndex: orderToSlotIndex})
    }

    deleteActiveSlot() {
        let activeSlotId = this.state.activeSlotId;
        deleteDoc(doc(this.props.rootPath, activeSlotId)).catch(() => {
            this.props.displayMessage(`${OPERATION_FAILED} ${WRITE_FAILED_DETAIL}`);
        });
        let newSlotId = super.deleteActiveSlot();
        if (newSlotId === undefined) {
            return undefined;
        }
        return newSlotId;
    }

    addSlot(attributes) {
        let orders = this.state.orderToSlotIndex.map((key) => this.order[key]);
        let newSlotKey = findAppendedOrder(orders);

        let newAttributes = this.getDefaultAttributes();
        for (let key in attributes) {
            newAttributes[key] = attributes[key];
        }

        addDoc(this.props.rootPath, {
            attributes: newAttributes,
            order: newSlotKey
        }).then((docRef) => {
            this.switchSlot(docRef.id);
        }).catch((error) => {
            console.error("Error adding document: ", error);
            this.props.displayMessage(`${OPERATION_FAILED} ${WRITE_FAILED_DETAIL}`);
        });
    }

    //TODO: QuickFix method for DynamicSlotListList to push attributes (make more general)
    pushAllAttributes() {
        for (let slotId in this.slotRefs) {
            this.slotRefs[slotId].current.saveData(undefined);
        }
    }

    render() {
        if (this.props.hide) {
            return null;
        }
        return super.render();
    }
}